const storagePrefix = "seedwills_";

const storage = {
  getToken: () => {
    return JSON.parse(window.localStorage.getItem(`${storagePrefix}token`));
  },
  setToken: (token) => {
    window.localStorage.setItem(`${storagePrefix}token`, JSON.stringify(token));
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
  },
  getRole: () => {
    return window.localStorage.getItem(`${storagePrefix}role`);
  },
  setRole: (role) => {
    if (role) {
      window.localStorage.setItem(`${storagePrefix}role`, role);
    }
  },
  clearRole: () => {
    window.localStorage.removeItem(`${storagePrefix}role`);
  },
};

export default storage;
